import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import RestService from "./../../Restservice";
import GlobalHelmet from "./../../GlobalHelmet";
import { Link } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    padding: "25px 5px !important",
  },
  label: {
    display: "block",
  },
  footer: {
    background: "#d1e6a3",
    padding: "0 10px 5px",
    fontWeight: "700",
    display: "flex",
  },
  circle: {
    color: "#0a0",
    fontSize: "20px",
    marginLeft: "auto",
    cursor: "pointer",
  },
}));

function RowData({ items }) {
  if (parseInt(items.value) > 0) {
    return (
      <tr>
        <td>{items.date}</td>
        <td
          className="text-center"
          style={{ color: items.value < 0 ? "red" : "green" }}
        >
          {items.value}%
        </td>
        <td
          className="text-center"
          style={{ color: items.chg < 0 ? "red" : "green" }}
        >
          {items.chg}%
        </td>
      </tr>
    );
  }
  return "";
}

export default function Index() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [updatedDate, setupdatedDate] = useState(false);
  const [curDate, setcurDate] = React.useState(true);
  const [value, setValue] = React.useState("all");
  const [winningRes, setWinningRes] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handletype = (event, updatedtype) => {
    setLoading(true);
    RestService.getScreener(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.getDetails);
        setupdatedDate(response.data.updatedDate);
        setcurDate(response.data.curDate);
      },
      updatedtype,
      value
    );
  };
  useEffect(() => {
    setLoading(true);
    RestService.getScreener(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.getDetails);
        setupdatedDate(response.data.updatedDate);
        setcurDate(response.data.curDate);
      },
      1,
      value
    );
  }, [value]);

  const showTechnicalModal = (items) => {
    setWinningRes(null);
    RestService.getScreenerWinning(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setWinningRes(response.data.result);
      },
      1,
      value,
      items?.tile_id
    );
    setTitle(items.tileName);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <table className="table table-bordered">
            <thead>
              <th>Date</th>
              <th>Winning Rate</th>
              <th>Nifty(%CH)</th>
            </thead>
            <tbody>
              {winningRes &&
                winningRes.map((items) => (
                  <RowData key={items.date} items={items} />
                ))}
            </tbody>
          </table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <GlobalHelmet {...Common?.screener} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="Screener" />

              <div className="row  ">
                <div className="col-md-6">
                  <button
                    onClick={(event) => handletype(event, 1)}
                    className="btn btn-lg btn-success"
                  >
                    Bulish&nbsp;{" "}
                  </button>{" "}
                  &nbsp;&nbsp;
                  <Link
                    to="/screener/most-common"
                    className="btn btn-lg btn-success"
                  >
                    Most Common
                  </Link>{" "}
                  &nbsp;&nbsp;
                  <button
                    onClick={(event) => handletype(event, 2)}
                    className="btn btn-lg btn-danger"
                  >
                    Bearish
                  </button>
                </div>
                <div className="col-md-6">
                  <RadioGroup
                    aria-label="signaltype"
                    name="signaltype"
                    value={value}
                    onChange={handleChange}
                  >
                    <div className="row">
                      <div className="col-12 text-right">
                        <FormControlLabel
                          value="61"
                          control={<Radio />}
                          label="FNO"
                        />

                        <FormControlLabel
                          value="64"
                          control={<Radio />}
                          label="NIFTY500"
                        />

                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="ALL"
                        />

                        <div className="signalDate"> {updatedDate} </div>
                      </div>
                    </div>
                  </RadioGroup>
                </div>
              </div>

              <div>
                <Grid container spacing={2}>
                  {globaldata ? (
                    globaldata.map((items) => (
                      <Grid item key={items.slug} xs={6} sm={4} md={4} lg={2}>
                        <Link
                          to={
                            "/screener/" +
                            items.slug +
                            "/" +
                            value +
                            "/" +
                            curDate
                          }
                        >
                          <Paper
                            className={"custom-grid-style " + classes.paper}
                          >
                            {items.tileName}
                            <label className={classes.label}>
                              ({items.counter})
                            </label>
                          </Paper>
                        </Link>

                        <div className={classes.footer}>
                          {items.winningList > 0 && (
                            <span>{items.winningList}%</span>
                          )}
                          <i
                            onClick={(e) => showTechnicalModal(items)}
                            className={`${classes.circle} fa fa-info-circle`}
                            title="View More Data"
                          ></i>
                        </div>
                      </Grid>
                    ))
                  ) : (
                    <Loader />
                  )}
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
